import React from 'react';
import { STRINGS } from '../utils/constants';

const DashboardHeader = ({ isDarkMode, onToggleTheme }) => (
  <div className="dashboard-header-bar">
    <div className="header-title-section">
      <h2>{STRINGS.dashboardTitle}</h2>
      <p>{STRINGS.dashboardSubtitle}</p>
    </div>
    <div className="header-controls">
      <button
        type="button"
        className="control-btn"
        onClick={onToggleTheme}
        title={STRINGS.toggleTheme}
        aria-label={STRINGS.toggleTheme}
      >
        <i className={`fa ${isDarkMode ? 'fa-sun-o' : 'fa-moon-o'}`} />
      </button>
    </div>
  </div>
);

export default DashboardHeader;
